module.exports = __webpack_public_path__ + "static/media/DOUBLE WELT X3.1bae5cbb.svg";